// extracted by mini-css-extract-plugin
export default {"line":"hero-line-module__line___eq+N2","badge":"hero-line-module__badge___rRMmb","text":"hero-line-module__text___hHUM5"};